import { all } from 'redux-saga/effects';

import invoicesSaga from './invoices';
import accountDetailsSaga from './accountDetails';
import paymentMethodsSaga from './paymentMethods';
import userDetailsSaga from './userDetails';
import pricingPlan from './account/pricingPlan';
import usersSaga from './users';
import ssoConfigurationSaga from './ssoConfiguration';
import twoFactorConfiguration from './twoFactorConfiguration';
import partnerAdAccountsSaga from './partnerAdAccounts/partnerAdAccounts';
import accountDataSaga from './accountData';
import historyEvents from './historyEvents';
import trackerSaga from './tracker/tracker';
import partnerSaga from './partner/partner';
import userPermissionSaga from './userPermission/userPermission';
import appSaga from './app/app';

export default function* rootSaga() {
  yield all([
    invoicesSaga(),
    accountDetailsSaga(),
    paymentMethodsSaga(),
    userDetailsSaga(),
    pricingPlan(),
    usersSaga(),
    ssoConfigurationSaga(),
    twoFactorConfiguration(),
    partnerAdAccountsSaga(),
    accountDataSaga(),
    historyEvents(),
    trackerSaga(),
    partnerSaga(),
    userPermissionSaga(),
    appSaga(),
  ]);
}
